<template>
  <div id="applyResult">
    <div v-if="merchant">
      <cube-form :model="merchant">
        <cube-form-group legend="申请信息">
          <cube-form-item :field="fields[21]"></cube-form-item>
          <cube-form-item :field="fields[22]">
            <div class="field" v-if="merchant.auditResult" style="color: red">拒绝</div>
            <div class="field" v-else style="color: orange">审核中</div>
          </cube-form-item>
          <cube-form-item :field="fields[23]" v-if="merchant.auditResult">
            <div class="field" style="color: red">{{ merchant.auditResult }}</div>
          </cube-form-item>
          <cube-form-item :field="fields[24]" v-if="merchant.auditResult">
            <div class="field">{{ merchant.auditor }}</div>
          </cube-form-item>
        </cube-form-group>
        <cube-form-group v-if="merchant.auditResult" legend="操作">
          <cube-button :inline="true" @click="goToApply" style="margin: 5px 10px; width: 100px" :primary="true">去修改</cube-button>
        </cube-form-group>
        <cube-form-group legend="检测站信息">
          <cube-form-item :field="fields[0]"></cube-form-item>
          <cube-form-item :field="fields[1]"></cube-form-item>
          <cube-form-item :field="fields[2]"></cube-form-item>
          <cube-form-item :field="fields[3]"></cube-form-item>
          <cube-form-item :field="fields[4]">
            <div class="field">{{ dsTypeMap[merchant.dsType] }}</div>
          </cube-form-item>
          <cube-form-item :field="fields[5]"></cube-form-item>
          <cube-form-item :field="fields[6]"></cube-form-item>
          <cube-form-item :field="fields[7]"></cube-form-item>
          <cube-form-item :field="fields[8]"></cube-form-item>
          <cube-form-item :field="fields[9]"></cube-form-item>
          <cube-form-item :field="fields[10]"></cube-form-item>
          <cube-form-item :field="fields[11]"></cube-form-item>
          <cube-form-item :field="fields[12]"></cube-form-item>
        </cube-form-group>
        <cube-form-group legend="联系人信息">
          <cube-form-item :field="fields[13]"></cube-form-item>
          <cube-form-item :field="fields[14]"></cube-form-item>
          <cube-form-item :field="fields[15]"></cube-form-item>
          <cube-form-item :field="fields[16]"></cube-form-item>
          <cube-form-item :field="fields[17]"></cube-form-item>
          <cube-form-item :field="fields[18]"></cube-form-item>
          <cube-form-item :field="fields[19]"></cube-form-item>
          <cube-form-item :field="fields[20]"></cube-form-item>
        </cube-form-group>
      </cube-form>
    </div>
    <div v-else>
      <div class="message">您还未进行申请，立即去<span @click="goToApply" class="to-apply-btn">申请</span></div>
    </div>
  </div>
</template>

<script>

import {queryApplicationsByOpenId} from '../modules/services/basic-service'

export default {
  name: 'applyResult',
  data () {
    return {
      dsTypeMap: {
        100: "内资",
        110: "国有全资",
        120: "集体全资",
        130: "股份合作",
        140: "联 营",
        141: "国有联营",
        142: "集体联营",
        143: "国有与集体联营",
        149: "其他联营",
        150: "有限责任(公司)",
        159: "其他有限责任(公司)",
        160: "股份有限(公司)",
        170: "私有",
        171: "私有独资",
        172: "私有合伙",
        173: "私营有限责任(公司)",
        174: "私营股份有限(公司)",
        175: "个体经营",
        179: "其他私有",
        190: "其他内资",
        900: "其 他"
      },
      success: false,
      message: '',
      merchant: null,
      fields: [
        {
          type: 'input',
          modelKey: 'merchantName',
          label: '机构名称',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'cityName',
          label: '所在盟市',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'merchantAddress',
          label: '经营地址',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'createStationDate',
          label: '成立日期',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'dsType',
          label: '企业性质',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'orgnumber',
          label: '统一社会信息代码',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'email',
          label: '企业邮箱',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'ma',
          label: '标定/标准证书编号',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'maExpDate',
          label: '标定/标准证书到期日期',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'staffNumber',
          label: '人员数量',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'detectCapYear',
          label: '机构年检测能力',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'detectCapMonth',
          label: '机构月检测能力',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'detectCapDay',
          label: '机构日检测能力',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'contactName',
          label: '负责人',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'contactPhone',
          label: '负责人联系电话',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'operator',
          label: '操作员',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'operatorPhone',
          label: '操作员联系电话',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'accountant',
          label: '财务',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'accountantPhone',
          label: '财务联系电话',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'technician',
          label: '技术员',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'technicianPhone',
          label: '技术员联系电话',
          props: {
            readonly: true
          }
        },
        {
          type: 'input',
          modelKey: 'createTime',
          label: '申请时间',
          props: {
            readonly: true
          }
        },
        {
          label: '申请状态'
        },
        {
          label: '拒绝原因',
          modelKey: 'auditResult',
          props: {
            readonly: true
          }
        },
        {
          label: '审核人',
          modelKey: 'auditor',
          props: {
            readonly: true
          }
        }
      ]
    }
  },
  created () {
    if (!this.$route.query.openId) {
      this.$router.push({
        path: '/authorize-fail?reason=未获取到微信用户ID'
      })
    } else {
      const self = this
      queryApplicationsByOpenId(this.$route.query.openId).then(({body}) => {
        if (body) {
          self.merchant = body
        }
      })
    }
  },
  methods: {
    goToApply () {
      this.$router.push({
        path: 'apply?openId=' + this.$route.query.openId
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
#applyResult {
  .field {
    text-align: right
    color: #666
  }
  .message {
    font-size: 16px;
    font-weight: bold
    text-align: center;
    padding: 20px 10px;
    border-bottom 1px solid #666
  }
  .success {
    color: green
  }
  .to-apply-btn {
    color: orangered
    border-bottom 1px solid orangered
  }
}
</style>

<style lang="stylus">
  #applyResult {
    .cube-form-group-legend {
      padding: 10px
    }
    .cube-form_standard .cube-form-label {
      width: 120px
    }
    .cube-form-field {
      .cube-input input {
        text-align right
      }
    }
  }
</style>